import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/error-fill-red.svg'


const _hoisted_1 = { class: "flex items-center justify-between mt-6 mb-6" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Filter kupon: ", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_6 = { class: "text-left break-words text-grey font-bold text-sm" }
const _hoisted_7 = { class: "text-left break-words text-grey font-bold text-sm" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "error"
}, null, -1)
const _hoisted_10 = { class: "text-left break-words text-grey text-sm" }
const _hoisted_11 = { class: "text-left break-words text-grey text-sm" }
const _hoisted_12 = { class: "text-left break-words text-grey text-sm" }
const _hoisted_13 = { class: "text-left break-words text-grey text-sm" }
const _hoisted_14 = { class: "text-left break-words text-grey text-sm" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('Approve'))
const _hoisted_16 = {
  key: 1,
  class: "text-left break-words text-grey text-sm"
}
const _hoisted_17 = ["onClick"]

import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import Paginator from '@/views/components/paginator/Paginator.vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import { onMounted, ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import numberFormat from '@/utils/helpers/numberFormat'
import moment from 'moment'
import { useRouter } from 'vue-router'
import Button from 'primevue/button'
import OverlayPanel from 'primevue/overlaypanel'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import Popper from 'vue3-popper'
import ListAction from './components/ListAction.vue'
import ApproveCouponDialog from './components/ApproveCoupon.vue'
import DataAfterScanDialog from './components/DataAfterScanDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OperationalList',
  setup(__props) {

const fuelVouchersEndpoint = '/transaction/v2/FuelTransactionVouchers'
const store = useStore()
const router = useRouter()
const app = getCurrentInstance()
const {
  $toast, $strInd, $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const refOverlayAction = ref()
const inputSearch = ref('')
const dataRow = ref(null) as any
const dataWaitingApprovalId = ref(null) as any
const showScannerDialog = ref(false)
const showDataAfterScanDialog = ref(false)
const selectedFilter = ref(2)
const dataSource = ref([]) as any
const filtersOptions = ref([
  { name: 'Expired', index: 0, value: 'Expired' },
  { name: 'Scan', index: 1, value: 'Used' },
  { name: 'Semua Kupon', index: 2, value: null },
])
const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  rowPerPageOptions: [5, 10],
  custom: [['category', '=', 'Operational'], ['orderBy', '=', 'IsNeedToApprove desc']]
})

const hideOverlay = () => {
  refOverlayAction.value.hide()
  dataRow.value = null
}

const showDropDown = (evt: any, item: any) => {
  dataRow.value = item
  refOverlayAction.value.toggle(evt)
}

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${fuelVouchersEndpoint}${returnUrlPrams(filters.value)}`).then((response) => {
    const { count, result, error } = response
    if (!error) {
      filters.value.totalRecords = count
      dataSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const onChangePage = ({ page, rows }: any) => {
  // console.log('page', page)
  filters.value.pageSize = rows
  filters.value.pageNumber = page + 1
  getAllData()
}

const setFilters = (data: any) => {
  filters.value.custom = [['category', '=', 'Operational'], ['orderBy', '=', 'IsNeedToApprove desc']]
  selectedFilter.value = data.index
  if (data.index === 1) {
    const filterTemp = filters.value.custom.findIndex((item: any) => item[0] === 'isNeedToApprove')
    if (filterTemp !== -1) {
      if (data.value) {
        filters.value.custom[filterTemp][2] = 'true'
      } else {
        filters.value.custom = filters.value.custom.filter((d: any) => d[0] !== 'isNeedToApprove')
      }
    } else {
      filters.value.custom.push(['isNeedToApprove', '=', 'true'])
    }
  } else if (data.index === 0) {
    const filterTemp = filters.value.custom.findIndex((item: any) => item[0] === 'status')
    if (filterTemp !== -1) {
      if (data.value) {
        filters.value.custom[filterTemp][2] = data.value
      } else {
        filters.value.custom = filters.value.custom.filter((d: any) => d[0] !== 'status')
      }
    } else {
      filters.value.custom.push(['status', '=', data.value])
    }
  }
  filters.value.pageNumber = 1
  getAllData()
}

const showDataAfterScanDialogAct = () => {
  showDataAfterScanDialog.value = true
  dataWaitingApprovalId.value = null
}

const hideDataAfterScanDialogAct = () => {
  showDataAfterScanDialog.value = false
  dataWaitingApprovalId.value = null
  dataRow.value = null
}

const onApprove = (data: any) => {
  // console.log('data', data)
  dataWaitingApprovalId.value = data.Id
  // console.log('dataWaitingApprovalId', dataWaitingApprovalId.value)
  showScannerDialog.value = true
}

const hideApproveDialog = () => {
  showScannerDialog.value = false
  dataWaitingApprovalId.value = null
}

const onDetectCouponAct = async (data: any) => {
  // console.log('data', data)
  const scannedData = data.data.split(':')
  try {
    await apiUseCase.get(`${fuelVouchersEndpoint}/${scannedData[0]}`).then((response) => {
      const { result, error, message } = response
      if (!error) {
        // hideApproveDialog()
        // console.log('compare', [dataWaitingApprovalId.value, result.Id])
        showScannerDialog.value = false
        if (dataWaitingApprovalId.value === result.Id) {
          dataRow.value = result
          showDataAfterScanDialogAct()
        } else {
          $toast.add({
            severity: 'error',
            summary: 'Gagal!',
            detail: 'Kode QR tidak sesuai dengan data yang akan diapprove. Silahkan periksa kembali.',
            group: 'bc',
            closable: false,
            life: 3000
          })
          dataWaitingApprovalId.value = null
        }
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal!',
          detail: 'Kode QR tidak sesuai dengan data yang akan diapprove. Silahkan periksa kembali.',
          group: 'bc',
          closable: false,
          life: 3000
        })
        dataWaitingApprovalId.value = null
      }
    })
  } catch (error) {
    // console.log('error', error)
    $toast.add({
      severity: 'error',
      summary: 'Gagal!',
      detail: error,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
}

const onAfterApprovedAct = async () => {
  // console.log('after')
  try {
    const payload = {
      id: dataRow.value?.Id
    }
    await apiUseCase.postWithNoId(`${fuelVouchersEndpoint}/${dataRow.value.Id}/Approve`, payload).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          summary: 'Kupon berhasil diapprove!',
          // detail: 'Kode QR tidak sesuai dengan data yang akan diapprove. Silahkan periksa kembali.',
          group: 'bc',
          closable: false,
          life: 3000
        })
        getAllData()
        hideDataAfterScanDialogAct()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal!',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
        hideDataAfterScanDialogAct()
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal!',
      detail: error,
      group: 'bc',
      closable: false,
      life: 3000
    })
    hideDataAfterScanDialogAct()
  }
}

const showDetailAct = () => {
  // console.log('showDetailAct', dataRow.value)
  router.push({
    name: 'master-fuel-coupon-form',
    params: { id: encryptDecriptMethods.encrypt(dataRow.value) }
  })
}

const onSearch = () => {
  filters.value.search = inputSearch.value
  filters.value.pageNumber = 1
  getAllData()
}

onMounted(() => {
  getAllData()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtersOptions.value, (dataFilter) => {
          return (_openBlock(), _createElementBlock("div", {
            key: dataFilter.index,
            class: _normalizeClass(["px-4 py-1 rounded-xl cursor-pointer", selectedFilter.value === dataFilter.index ? 'border-primary background-blue-4 text-primary' : 'border-grey-3']),
            onClick: ($event: any) => (setFilters(dataFilter))
          }, _toDisplayString(dataFilter.name), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _createVNode(InputIconRight, {
          class: "input-search-header-custom",
          placeholder: "Cari nopol atau nama kru ...",
          modelValue: inputSearch.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
          canClick: true,
          icon: _unref(icon).svg.searchEva,
          onSubmitInput: onSearch,
          onKeyup: _withKeys(onSearch, ["enter"])
        }, null, 8, ["modelValue", "icon", "onKeyup"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createVNode(_unref(DataTable), {
          value: _unref(dataSource),
          rows: 5,
          class: "w-full"
        }, {
          empty: _withCtx(() => [
            _hoisted_5
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { header: "Nopol - Kru" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("p", _hoisted_6, _toDisplayString(data.VehicleRegNumber ?? '-'), 1),
                _createElementVNode("p", _hoisted_7, [
                  _createTextVNode(_toDisplayString(data.CrewName ?? '-') + " ", 1),
                  (data.Status === 'Used')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createVNode(_unref(Popper), {
                          arrow: "",
                          hover: "",
                          placement: "bottom",
                          content: "Kupon belum diapprove"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Jenis - Liter" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("p", _hoisted_10, _toDisplayString(data.FuelingType === 'FullTank' ? `${data.FuelingTypeDisplayName}` : `${data.FuelingTypeDisplayName} - ${_unref(numberFormat)(data.LitersQty)}L`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Tgl Berlaku" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("p", _hoisted_11, _toDisplayString(`${_unref(moment)(data.StartDate).format('DD/MM/YYYY')} - ${_unref(moment)(data.EndDate).format('DD/MM/YYYY')}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Tgl Isi" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("p", _hoisted_12, _toDisplayString(`${data.ClaimedAt ? _unref(moment)(data.ClaimedAt).format('DD/MM/YYYY') : '-'}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Nama Pom" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("p", _hoisted_13, _toDisplayString(data.FuelingTransaction?.FuelStationPartnerName ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Tgl Scan" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("p", _hoisted_14, _toDisplayString(`${data.Status === 'Approved' && data.UpdatedAt ? _unref(moment)(data.UpdatedAt).format('DD/MM/YYYY') : '-'}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Approve" }, {
              body: _withCtx(({ data }) => [
                (data.Status === 'Used')
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      type: "button",
                      class: "btn-primary",
                      onClick: ($event: any) => (onApprove(data))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_16, "-"))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("i", {
                  class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                  onClick: ($event: any) => (showDropDown($event, data))
                }, null, 8, _hoisted_17)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (filters.value.totalRecords > 0)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            rows: filters.value.pageSize,
            totalRecords: filters.value.totalRecords,
            onOnPage: onChangePage,
            rowsPerPageOptions: filters.value.rowPerPageOptions
          }, null, 8, ["rows", "totalRecords", "rowsPerPageOptions"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction
    }, {
      default: _withCtx(() => [
        _createVNode(ListAction, {
          showDetail: true,
          onShowDetail: showDetailAct
        })
      ]),
      _: 1
    }, 512),
    (showScannerDialog.value)
      ? (_openBlock(), _createBlock(ApproveCouponDialog, {
          key: 0,
          isShowDialog: showScannerDialog.value,
          onHideDialog: hideApproveDialog,
          onOnDetect: onDetectCouponAct
        }, null, 8, ["isShowDialog"]))
      : _createCommentVNode("", true),
    (showDataAfterScanDialog.value)
      ? (_openBlock(), _createBlock(DataAfterScanDialog, {
          key: 1,
          isShowDialog: showDataAfterScanDialog.value,
          data: _unref(dataRow),
          onHideDialog: hideDataAfterScanDialogAct,
          onOnAfterApproved: onAfterApprovedAct
        }, null, 8, ["isShowDialog", "data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})